import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import "../../assets/css/Bill.css";
import { useNavigate } from 'react-router-dom';

export default function OrderSmallBill() {
  const { order_no } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [ordersData, setOrdersData] = useState(null);
  const navigate = useNavigate(); // hook called inside component

  useEffect(() => {
    if (order_no) {
      fetchordersData();
    }
  }, [order_no]);

  const fetchordersData = async () => {
    try {
      setLoading(true);
      console.log("Fetching for order_no:", order_no);

      const response = await axios.get(
        `${ApiUrl}/Api/orders.php?order_no=${order_no}`
      );

      console.log("API response:", response.data);

      const filteredData = response.data.data?.find(
        (item) => item.order_no === order_no
      );
      console.log("Filtered data:", filteredData);

      if (filteredData) {
        setOrdersData(filteredData);
      } else {
        setError(`No sales data found for order number: ${order_no}`);
      }
    } catch (error) {
      console.error("API error:", error);
      setError("Failed to fetch sales data");
    } finally {
      setLoading(false);
    }
  };

  const numberToWords = (num) => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const numToWord = (n) => {
      if (n < 20) return ones[n];
      if (n < 100)
        return (
          tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
        );
      if (n < 1000)
        return (
          ones[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 !== 0 ? " and " + numToWord(n % 100) : "")
        );
      if (n < 100000)
        return (
          numToWord(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 !== 0 ? " " + numToWord(n % 1000) : "")
        );
      if (n < 10000000)
        return (
          numToWord(Math.floor(n / 100000)) +
          " Lakh" +
          (n % 100000 !== 0 ? " " + numToWord(n % 100000) : "")
        );
      return (
        numToWord(Math.floor(n / 10000000)) +
        " Crore" +
        (n % 10000000 !== 0 ? " " + numToWord(n % 10000000) : "")
      );
    };

    const decimalToWord = (decimalPart) => {
      if (decimalPart === 0) return "";
      const decStr = decimalPart.toString().padEnd(2, "0");
      return " and " + numToWord(parseInt(decStr)) + " Paise";
    };

    const parts = num.toString().split(".");
    const integerPart = parseInt(parts[0]);
    const decimalPart =
      parts.length > 1 ? parseInt(parts[1].padEnd(2, "0").substring(0, 2)) : 0;

    let result = numToWord(integerPart) + " Rupees";
    if (decimalPart > 0) {
      result += decimalToWord(decimalPart);
    }

    return result;
  };

  const calculatePureTotal = (itemList) => {
    if (!itemList || !Array.isArray(itemList)) return 0;
    return itemList.reduce((total, item) => {
      const weight = parseFloat(item.weight) || 0;
      const purity = 0.945;
      return total + weight * purity;
    }, 0);
  };

  if (loading)
    return <div className="flex justify-center p-4">Loading order data...</div>;
  if (error)
    return <div className="flex justify-center p-4 text-red-500">{error}</div>;
  if (!ordersData)
    return (
      <div className="flex justify-center p-4">No order data available</div>
    );

  const totalQuantity =
    ordersData.order_items?.reduce(
      (total, item) => total + parseInt(item.quantity || 0),
      0
    ) || 0;
  const totalWeight =
    ordersData.order_items?.reduce(
      (total, item) => total + parseFloat(item.weight || 0),
      0
    ) || 0;
  const purityValue = 94.5;
  const pureWeight = calculatePureTotal(ordersData.order_items);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return `${date.getDate().toString().padStart(2, "0")}-${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${date.getFullYear()}`;
    } catch (e) {
      return dateString;
    }
  };

  const receiptData = {
    date: formatDate(ordersData.order_date),
    party: ordersData.customer_info?.name || "SHEVAPET TIRUPPUR JEWELLERY",
    product_code: "TJS-" + ordersData.order_no,
    qty: totalQuantity,
    weight: totalWeight,
    purity: purityValue,
    fw: 0.0,
    pure: pureWeight,
    opening_pure: -0.313,
    current_pure: pureWeight,
    closing_pure: pureWeight - 0.313,
    items: ordersData.order_items || [],
    subTotal: parseFloat(ordersData.total) || 0,
    discount: 0,
    netTotal: parseFloat(ordersData.total) || 0,
    paid: parseFloat(ordersData.paid) || 0,
    balance: parseFloat(ordersData.balance) || 0,
    paidInWords: numberToWords(parseFloat(ordersData.paid) || 0),
  };

  const handlePrint = () => {
    window.print();
  };

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  return (
    <div className="receipt-container">
       <button className="cancel-btn no-print" onClick={() => navigate('/orders')}>
        Cancel
      </button>
      <div className="receipt">
        <div className="receipt-header">
          <img
            src={require("../../assets/images/Final logo c .png")}
            alt="Company Logo"
            className="receipt-logo"
          />
          <div className="receipt-title">Order Estimate</div>
        </div>
        <div
          className="receipt-info"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div>Date: {receiptData.date}</div>
          <div className="billno">Bill No: {ordersData.order_no}</div>
        </div>
        <div className="receipt-info">Party: {receiptData.party}</div>

        <div className="receipt-divider"></div>

        <div
          style={{
            display: "flex",
            width: "100%",
            fontSize: "10px",
            fontWeight: "bold",
            marginLeft: "20px",
          }}
        >
          <div style={{ width: "25%", textAlign: "left" }}>SNO</div>
          <div style={{ width: "20%", textAlign: "left" }}>Product</div>
          <div style={{ width: "20%", textAlign: "right" }}>Qty</div>
          <div style={{ width: "19%", textAlign: "right" }}>Wgt</div>
       
        </div>

        <div className="receipt-divider"></div>

        {receiptData.items.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              width: "95%",
              fontSize: "10px",
              marginLeft: "20px",
            }}
          >
            <div
              style={{ width: "25%", textAlign: "left", fontWeight: "bold" }}
            >
              {index + 1}
            </div>
            <div
              style={{
                width: "20%",
                fontWeight: "bold",
                textAlign: "left",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {truncateText(item.product, 10)}
            </div>
            <div
              style={{ width: "22%", textAlign: "right", fontWeight: "bold" }}
            >
              {item.quantity || ""}
            </div>
            <div
              style={{ width: "23%", textAlign: "right", fontWeight: "bold" }}
            >
              {parseFloat(item.weight || 0).toFixed(2)}g
            </div>
          
          </div>
        ))}

        <div className="receipt-divider"></div>

        <div
          style={{
            display: "flex",
            width: "95%",
            fontSize: "10px",
            marginLeft: "20px",
          }}
        >
          <div style={{ width: "10%", textAlign: "left", fontWeight: "bold" }}>
            Total
          </div>
          <div
            style={{ width: "25%", textAlign: "left", fontWeight: "bold" }}
          ></div>
          <div style={{ width: "45%", textAlign: "right", fontWeight: "bold" }}>
            {receiptData.qty}
          </div>
          <div style={{ width: "26%", textAlign: "right", fontWeight: "bold" }}>
            {receiptData.weight.toFixed(2)}g
          </div>
          <div
            style={{ width: "15%", textAlign: "right", fontWeight: "bold" }}
          ></div>
        </div>

        <div className="receipt-divider"></div>

        <div
          style={{
            display: "flex",
            width: "90%",
            fontSize: "10px",
            justifyContent: "flex-end",
          }}
        >
          <div style={{ width: "30%", textAlign: "right", fontWeight: "bold" }}>
            Amount
          </div>
        </div>

        <div className="receipt-divider"></div>

        <div
          style={{
            display: "flex",
            width: "85%",
            fontSize: "10px",
            marginLeft: "20px",
          }}
        >
          <div style={{ width: "60%", textAlign: "left", fontWeight: "bold" }}>
            Total
          </div>
          <div style={{ width: "40%", textAlign: "right", fontWeight: "bold" }}>
            {receiptData.netTotal.toFixed(2)}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            width: "85%",
            fontSize: "10px",
            marginLeft: "20px",
          }}
        >
          <div style={{ width: "60%", textAlign: "left", fontWeight: "bold" }}>
            Paid
          </div>
          <div style={{ width: "40%", textAlign: "right", fontWeight: "bold" }}>
            {receiptData.paid.toFixed(2)}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            width: "85%",
            fontSize: "10px",
            marginLeft: "20px",
          }}
        >
          <div style={{ width: "60%", textAlign: "left", fontWeight: "bold" }}>
            Balance
          </div>
          <div style={{ width: "40%", textAlign: "right", fontWeight: "bold" }}>
            {receiptData.balance.toFixed(2)}
          </div>
        </div>

        <div className="receipt-divider"></div>
        <div
          style={{
            fontSize: "10px",
            padding: "5px 20px",
            textAlign: "left",
            fontWeight: "bold",
          }}
        >
          Amount Paid In Words:
        </div>
        <div
          style={{
            fontSize: "10px",
            padding: "0 20px 10px",
            textAlign: "left",
            fontStyle: "italic",
          }}
        >
          {receiptData.paidInWords}
        </div>

        <div className="receipt-divider"></div>
        <div className="receipt-footer page-break">
          Thank you for your business!
        </div>
      </div>

      <button onClick={handlePrint} className="print-button">
        Print Receipt
      </button>
    </div>
  );
}
